export enum AgencyTypeModel {
  SUBACCOUNTS = "subaccounts",
  PRICING_PLANS = "pricing-plans",
  PRODUCTS = "products",
  GENERAL_SETTINGS = "general-settings",
  PARTNER_DETAILS = "partner-details",
  LIMITS = "limits",
  PAYMENTS = "payments",
  PERMISSIONS = "permissions",
}

export enum ProductTypeModel {
  AGENT = "agent",
  TEAM = "team",
  WORKFLOW = "workflow",
  PHONE_NUMBERS = "phone-numbers",
  CUSTOM_ACTION = "custom-action",
  INFORMATION_EXTRACTOR = "information-extractor",
  CALL_TRANSFER = "call-transfer",
  SEND_SMS = "send-sms",
}
